import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _999675e2 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _75d023c8 = () => interopDefault(import('../pages/pallets/index.vue' /* webpackChunkName: "pages/pallets/index" */))
const _07b969e6 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _27971eda = () => interopDefault(import('../pages/shoppingList/index.vue' /* webpackChunkName: "pages/shoppingList/index" */))
const _cad79e9c = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _7c127f50 = () => interopDefault(import('../pages/brand/index.vue' /* webpackChunkName: "pages/brand/index" */))
const _72270b1d = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _168b6cb3 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _38ed3a5a = () => interopDefault(import('../pages/eco/index.vue' /* webpackChunkName: "pages/eco/index" */))
const _ac3a22c6 = () => interopDefault(import('../pages/promotions/index.vue' /* webpackChunkName: "pages/promotions/index" */))
const _3420942d = () => interopDefault(import('../pages/remindPassword/index.vue' /* webpackChunkName: "pages/remindPassword/index" */))
const _ba8a63a6 = () => interopDefault(import('../pages/punchOut/index.vue' /* webpackChunkName: "pages/punchOut/index" */))
const _cc080460 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _4aed0c39 = () => interopDefault(import('../pages/dashboard/disposal/index.vue' /* webpackChunkName: "pages/dashboard/disposal/index" */))
const _6cfe81d6 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _0aeef5af = () => interopDefault(import('../pages/acceptOrder/index.vue' /* webpackChunkName: "pages/acceptOrder/index" */))
const _8f6d6944 = () => interopDefault(import('../pages/siteMap/index.vue' /* webpackChunkName: "pages/siteMap/index" */))
const _93df0d34 = () => interopDefault(import('../pages/dashboard/list/index.vue' /* webpackChunkName: "pages/dashboard/list/index" */))
const _685f1e44 = () => interopDefault(import('../pages/dashboard/catalog-subset/index.vue' /* webpackChunkName: "pages/dashboard/catalog-subset/index" */))
const _177fbfdf = () => interopDefault(import('../pages/dashboard/offers/index.vue' /* webpackChunkName: "pages/dashboard/offers/index" */))
const _227a442b = () => interopDefault(import('../pages/dashboard/settings/index.vue' /* webpackChunkName: "pages/dashboard/settings/index" */))
const _ebe5b0a6 = () => interopDefault(import('../pages/dashboard/orders/index.vue' /* webpackChunkName: "pages/dashboard/orders/index" */))
const _8ee794b2 = () => interopDefault(import('../pages/dashboard/pendingOrders.vue' /* webpackChunkName: "pages/dashboard/pendingOrders" */))
const _1675e7b0 = () => interopDefault(import('../pages/dashboard/complaints/index.vue' /* webpackChunkName: "pages/dashboard/complaints/index" */))
const _2c3e3882 = () => interopDefault(import('../pages/dashboard/iframe-complaints/index.vue' /* webpackChunkName: "pages/dashboard/iframe-complaints/index" */))
const _abc8a858 = () => interopDefault(import('../pages/newsletter/confirm.vue' /* webpackChunkName: "pages/newsletter/confirm" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4ff73f59 = () => interopDefault(import('../pages/blog/author/_slug.vue' /* webpackChunkName: "pages/blog/author/_slug" */))
const _28b03768 = () => interopDefault(import('../pages/blog/category/_slug.vue' /* webpackChunkName: "pages/blog/category/_slug" */))
const _f3a6fd8a = () => interopDefault(import('../pages/blog/page/_number.vue' /* webpackChunkName: "pages/blog/page/_number" */))
const _75887f8e = () => interopDefault(import('../pages/pallets/page/_number.vue' /* webpackChunkName: "pages/pallets/page/_number" */))
const _08409c34 = () => interopDefault(import('../pages/dashboard/invoices/_slug.vue' /* webpackChunkName: "pages/dashboard/invoices/_slug" */))
const _974c4fc4 = () => interopDefault(import('../pages/dashboard/list/_slug.vue' /* webpackChunkName: "pages/dashboard/list/_slug" */))
const _6bcc60d4 = () => interopDefault(import('../pages/dashboard/catalog-subset/_slug.vue' /* webpackChunkName: "pages/dashboard/catalog-subset/_slug" */))
const _ef52f336 = () => interopDefault(import('../pages/dashboard/orders/_slug.vue' /* webpackChunkName: "pages/dashboard/orders/_slug" */))
const _2fab7b12 = () => interopDefault(import('../pages/dashboard/iframe-complaints/_slug.vue' /* webpackChunkName: "pages/dashboard/iframe-complaints/_slug" */))
const _14bf4668 = () => interopDefault(import('../pages/dashboard/complaints/_slug.vue' /* webpackChunkName: "pages/dashboard/complaints/_slug" */))
const _0c22dce0 = () => interopDefault(import('../pages/eco/page/_number.vue' /* webpackChunkName: "pages/eco/page/_number" */))
const _2a9a5475 = () => interopDefault(import('../pages/search/page/_number.vue' /* webpackChunkName: "pages/search/page/_number" */))
const _5bba9d69 = () => interopDefault(import('../pages/blog/author/page/_number.vue' /* webpackChunkName: "pages/blog/author/page/_number" */))
const _15871116 = () => interopDefault(import('../pages/blog/category/page/_number.vue' /* webpackChunkName: "pages/blog/category/page/_number" */))
const _013dbe8c = () => interopDefault(import('../pages/dashboard/catalog-subset/page/_number.vue' /* webpackChunkName: "pages/dashboard/catalog-subset/page/_number" */))
const _9d03b872 = () => interopDefault(import('../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _155df523 = () => interopDefault(import('../pages/category/_slug.vue' /* webpackChunkName: "pages/category/_slug" */))
const _92daabd4 = () => interopDefault(import('../pages/siteMap/_slug.vue' /* webpackChunkName: "pages/siteMap/_slug" */))
const _7a5bde08 = () => interopDefault(import('../pages/brand/_slug.vue' /* webpackChunkName: "pages/brand/_slug" */))
const _3362ffdb = () => interopDefault(import('../pages/checkout/_id.vue' /* webpackChunkName: "pages/checkout/_id" */))
const _9203cc20 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _afa76556 = () => interopDefault(import('../pages/promotions/_slug.vue' /* webpackChunkName: "pages/promotions/_slug" */))
const _dda08456 = () => interopDefault(import('../pages/remindPassword/_id.vue' /* webpackChunkName: "pages/remindPassword/_id" */))
const _710f3438 = () => interopDefault(import('../pages/register/_id.vue' /* webpackChunkName: "pages/register/_id" */))
const _53894561 = () => interopDefault(import('../pages/ats/_slug.vue' /* webpackChunkName: "pages/ats/_slug" */))
const _397ecffe = () => interopDefault(import('../pages/textPage/_slug.vue' /* webpackChunkName: "pages/textPage/_slug" */))
const _03fbb05f = () => interopDefault(import('../pages/category/page/_number.vue' /* webpackChunkName: "pages/category/page/_number" */))
const _7575ebda = () => interopDefault(import('../pages/brand/page/_number.vue' /* webpackChunkName: "pages/brand/page/_number" */))
const _0255c826 = () => interopDefault(import('../pages/promotions/page/_number.vue' /* webpackChunkName: "pages/promotions/page/_number" */))
const _15ff3e61 = () => interopDefault(import('../pages/ats/page/_number.vue' /* webpackChunkName: "pages/ats/page/_number" */))
const _2c447510 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _999675e2,
    pathToRegexpOptions: {"strict":true},
    name: "blog___pl"
  }, {
    path: "/hurtownia-artykulow-biurowych",
    component: _75d023c8,
    pathToRegexpOptions: {"strict":true},
    name: "pallets___pl"
  }, {
    path: "/koszyk",
    component: _07b969e6,
    pathToRegexpOptions: {"strict":true},
    name: "cart___pl"
  }, {
    path: "/lista-zakupowa",
    component: _27971eda,
    pathToRegexpOptions: {"strict":true},
    name: "shoppingList___pl"
  }, {
    path: "/logowanie",
    component: _cad79e9c,
    pathToRegexpOptions: {"strict":true},
    name: "login___pl"
  }, {
    path: "/marki",
    component: _7c127f50,
    pathToRegexpOptions: {"strict":true},
    name: "brand___pl"
  }, {
    path: "/moj-ofix",
    component: _72270b1d,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard___pl"
  }, {
    path: "/proces-zamowienia",
    component: _168b6cb3,
    pathToRegexpOptions: {"strict":true},
    name: "checkout___pl"
  }, {
    path: "/produkty-ekologiczne",
    component: _38ed3a5a,
    pathToRegexpOptions: {"strict":true},
    name: "eco___pl"
  }, {
    path: "/promocje",
    component: _ac3a22c6,
    pathToRegexpOptions: {"strict":true},
    name: "promotions___pl"
  }, {
    path: "/przypomnienie-hasla",
    component: _3420942d,
    pathToRegexpOptions: {"strict":true},
    name: "remindPassword___pl"
  }, {
    path: "/punch-out",
    component: _ba8a63a6,
    pathToRegexpOptions: {"strict":true},
    name: "punchOut___pl"
  }, {
    path: "/rejestracja",
    component: _cc080460,
    pathToRegexpOptions: {"strict":true},
    name: "register___pl"
  }, {
    path: "/utylizacja",
    component: _4aed0c39,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-disposal___pl"
  }, {
    path: "/wyszukiwarka",
    component: _6cfe81d6,
    pathToRegexpOptions: {"strict":true},
    name: "search___pl"
  }, {
    path: "/zaakceptuj-zamowienie",
    component: _0aeef5af,
    pathToRegexpOptions: {"strict":true},
    name: "acceptOrder___pl"
  }, {
    path: "/mapa-strony/kategorie",
    component: _8f6d6944,
    pathToRegexpOptions: {"strict":true},
    name: "siteMap___pl"
  }, {
    path: "/moj-ofix/lista",
    component: _93df0d34,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-list___pl"
  }, {
    path: "/moj-ofix/minikatalogi",
    component: _685f1e44,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-catalog-subset___pl"
  }, {
    path: "/moj-ofix/oferty",
    component: _177fbfdf,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-offers___pl"
  }, {
    path: "/moj-ofix/ustawienia",
    component: _227a442b,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-settings___pl"
  }, {
    path: "/moj-ofix/zamowienia",
    component: _ebe5b0a6,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-orders___pl"
  }, {
    path: "/moj-ofix/zamowienia-oczekujace",
    component: _8ee794b2,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-pendingOrders___pl"
  }, {
    path: "/moj-ofix/zwroty",
    component: _1675e7b0,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-complaints___pl"
  }, {
    path: "/moj-ofix/zwroty-iframe",
    component: _2c3e3882,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-iframe-complaints___pl"
  }, {
    path: "/newsletter/potwierdzenie",
    component: _abc8a858,
    pathToRegexpOptions: {"strict":true},
    name: "newsletter-confirm___pl"
  }, {
    path: "/",
    component: _2dfb1658,
    pathToRegexpOptions: {"strict":true},
    name: "index___pl"
  }, {
    path: "/blog/autor/:slug",
    component: _4ff73f59,
    pathToRegexpOptions: {"strict":true},
    name: "blog-author-slug___pl"
  }, {
    path: "/blog/kategoria/:slug",
    component: _28b03768,
    pathToRegexpOptions: {"strict":true},
    name: "blog-category-slug___pl"
  }, {
    path: "/blog/strona/:number",
    component: _f3a6fd8a,
    pathToRegexpOptions: {"strict":true},
    name: "blog-page-number___pl"
  }, {
    path: "/hurtownia-artykulow-biurowych/strona/:number",
    component: _75887f8e,
    pathToRegexpOptions: {"strict":true},
    name: "pallets-page-number___pl"
  }, {
    path: "/moj-ofix/faktury/:slug",
    component: _08409c34,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-invoices-slug___pl"
  }, {
    path: "/moj-ofix/lista/:slug",
    component: _974c4fc4,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-list-slug___pl"
  }, {
    path: "/moj-ofix/minikatalogi/:slug",
    component: _6bcc60d4,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-catalog-subset-slug___pl"
  }, {
    path: "/moj-ofix/zamowienia/:slug",
    component: _ef52f336,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-orders-slug___pl"
  }, {
    path: "/moj-ofix/zwroty-iframe/:slug",
    component: _2fab7b12,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-iframe-complaints-slug___pl"
  }, {
    path: "/moj-ofix/zwroty/:slug",
    component: _14bf4668,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-complaints-slug___pl"
  }, {
    path: "/produkty-ekologiczne/strona/:number",
    component: _0c22dce0,
    pathToRegexpOptions: {"strict":true},
    name: "eco-page-number___pl"
  }, {
    path: "/wyszukiwarka/strona/:number",
    component: _2a9a5475,
    pathToRegexpOptions: {"strict":true},
    name: "search-page-number___pl"
  }, {
    path: "/blog/autor/:slug/strona/:number",
    component: _5bba9d69,
    pathToRegexpOptions: {"strict":true},
    name: "blog-author-page-number___pl"
  }, {
    path: "/blog/kategoria/:slug/strona/:number",
    component: _15871116,
    pathToRegexpOptions: {"strict":true},
    name: "blog-category-page-number___pl"
  }, {
    path: "/moj-ofix/minikatalogi/:slug/strona/:number",
    component: _013dbe8c,
    pathToRegexpOptions: {"strict":true},
    name: "dashboard-catalog-subset-page-number___pl"
  }, {
    path: "/blog/:slug",
    component: _9d03b872,
    pathToRegexpOptions: {"strict":true},
    name: "blog-slug___pl"
  }, {
    path: "/kategoria/:slug",
    component: _155df523,
    pathToRegexpOptions: {"strict":true},
    name: "category-slug___pl"
  }, {
    path: "/mapa-strony/:slug",
    component: _92daabd4,
    pathToRegexpOptions: {"strict":true},
    name: "siteMap-slug___pl"
  }, {
    path: "/marka/:slug",
    component: _7a5bde08,
    pathToRegexpOptions: {"strict":true},
    name: "brand-slug___pl"
  }, {
    path: "/proces-zamowienia/:id",
    component: _3362ffdb,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-id___pl"
  }, {
    path: "/produkt/:slug",
    component: _9203cc20,
    pathToRegexpOptions: {"strict":true},
    name: "product-slug___pl"
  }, {
    path: "/promocje/:slug",
    component: _afa76556,
    pathToRegexpOptions: {"strict":true},
    name: "promotions-slug___pl"
  }, {
    path: "/przypomnienie-hasla/:id",
    component: _dda08456,
    pathToRegexpOptions: {"strict":true},
    name: "remindPassword-id___pl"
  }, {
    path: "/rejestracja/:id",
    component: _710f3438,
    pathToRegexpOptions: {"strict":true},
    name: "register-id___pl"
  }, {
    path: "/szukaj/:slug",
    component: _53894561,
    pathToRegexpOptions: {"strict":true},
    name: "ats-slug___pl"
  }, {
    path: "/textPage/:slug?",
    component: _397ecffe,
    pathToRegexpOptions: {"strict":true},
    name: "textPage-slug___pl"
  }, {
    path: "/kategoria/:slug/strona/:number",
    component: _03fbb05f,
    pathToRegexpOptions: {"strict":true},
    name: "category-page-number___pl"
  }, {
    path: "/marka/:slug/strona/:number",
    component: _7575ebda,
    pathToRegexpOptions: {"strict":true},
    name: "brand-page-number___pl"
  }, {
    path: "/promocje/:slug/strona/:number",
    component: _0255c826,
    pathToRegexpOptions: {"strict":true},
    name: "promotions-page-number___pl"
  }, {
    path: "/szukaj/:slug/strona/:number",
    component: _15ff3e61,
    pathToRegexpOptions: {"strict":true},
    name: "ats-page-number___pl"
  }, {
    path: "/:slug",
    component: _2c447510,
    pathToRegexpOptions: {"strict":true},
    name: "slug___pl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
